import { createFileRoute } from '@tanstack/react-router'
import RegisterPage from '../pages/AuthPage/RegisterPage';

export const Route = createFileRoute('/register')({
  component: RegisterPage,
});
